/* eslint-disable yoda */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@ps-design-system/components/Button';
import { useToast } from '@ps-design-system/components/Toast';
import PlusIcon from '@ps-design-system/icons/Plus/Plus20';

import { useUploadModal } from '../../context/UploadModalContext';
import { useUploaderPageData } from '../../context/UploaderPageContext';
import { useUploaderActions } from '../../hooks/useUploaderActions';
import useUploaderStore from '../../store/useUploaderStore';
import { isMinimumPhotoRequirementMet, isEmbedMedia } from '../../utils/media.utils';
import { TOAST_DURATION } from '../../constants/actions.consts';

const UploaderBottomNavigationMobile = () => {
  const { isListing, spaceId, router } = useUploaderPageData();
  const { openMediaModal } = useUploadModal();
  const { handleSave } = useUploaderActions();
  const { toast } = useToast();
  const media = useUploaderStore((state) => state.media);

  const handleSaveClick = () => {
    let hasError = false;
    const firstItem = media[0];

    if (!isMinimumPhotoRequirementMet(media)) {
      toast({
        title: '',
        description: <FormattedMessage id="uploader.toast.error_minimum" defaultMessage="5 photos are required for your listing"/>,
        variant: 'destructive',
        duration: TOAST_DURATION
      });
      hasError = true;
    }
    if (isEmbedMedia(firstItem)) {
      toast({
        title: '',
        description: <FormattedMessage id="uploader.toast.error_cover" defaultMessage="Videos and 3D tours cannot be used as cover photos"/>,
        variant: 'destructive',
        duration: TOAST_DURATION
      });
      hasError = true;
    }

    if (hasError) {
      return;
    }

    handleSave();

    if (!isListing) {
      router.push(`/your-space/${spaceId}/availability`);
    }
  };

  return (
    <div className="uploader-bottom-navigation tw-bg-base-white tw-border-t tw-border-t-gray-300">
      <div>
        <Button
          appearance="black"
          prefix={<PlusIcon />}
          fullWidth
          onClick={openMediaModal}
          attributes={{ 'data-testing-id': 'upload-button-footer' }}
        >
          <FormattedMessage id="uploader.page.upload" defaultMessage="Upload"/>
        </Button>
      </div>

      <div className="next-button">
        {isListing
          ? (
            <Button
              appearance="white"
              variant="outline-1"
              fullWidth
              showSpinner={false}
              onClick={handleSaveClick}
              attributes={{ 'data-testing-id': 'upload-save-footer' }}
            >
              <FormattedMessage id="uploader.page.save" defaultMessage="Save"/>
            </Button>
          )
          : (
            <Button
              appearance="white"
              variant="outline-1"
              fullWidth
              showSpinner={false}
              onClick={handleSaveClick}
              attributes={{ 'data-testing-id': 'upload-next-footer' }}
            >
              <FormattedMessage id="uploader.page.next" defaultMessage="Next"/>
            </Button>
          )
        }
      </div>
    </div>
  );
};

export default UploaderBottomNavigationMobile;
